import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../services/config';
import { TransportPlannerProfileDetails, TransportPlannerProfileModel } from '../models';
import { TransportPlannerProfileEndpoint } from '../constants/transport-planner-profile-endpoint';

@Injectable({
  providedIn: 'root',
})
export class TransportPlannerProfileItemBriefService {
  constructor(private http: WrapperHttpService) {}

  saveTransportPlannerProfile(body: TransportPlannerProfileDetails): Observable<TransportPlannerProfileDetails> {
    const url = `${API_URL}${TransportPlannerProfileEndpoint.Base}${TransportPlannerProfileEndpoint.Profiles}`;
    return this.http.withLoading().patch<TransportPlannerProfileModel>(url, body);
  }

  cloneTransportPlannerProfile(body: TransportPlannerProfileDetails): Observable<TransportPlannerProfileDetails> {
    const url = `${API_URL}${TransportPlannerProfileEndpoint.Base}${TransportPlannerProfileEndpoint.Profiles}${TransportPlannerProfileEndpoint.Clone}`;
    return this.http.withLoading().post<TransportPlannerProfileDetails>(url, body);
  }

  deleteTransportPlannerProfile(profileId: number): Observable<TransportPlannerProfileModel> {
    const url = `${API_URL}${TransportPlannerProfileEndpoint.Base}${TransportPlannerProfileEndpoint.Profiles}/${profileId}`;
    return this.http.withLoading().delete<TransportPlannerProfileModel>(url);
  }
}
